import React from 'react';
import { UserAppTransaction } from '@dxb-web-ui-framework/iam/domain/AccessControl/entities';
import { ClientSideWizardConfiguration } from '../../../../content-composer/src/contexts/ClientSideWizard/types';
import { useUserInfoIsUserAllowedAction } from '../../../../userProfile/src/contexts/UserInfo/hooks';
import { RoutingTransferTypes } from '../../domain/Transfer/entities/RoutingResponseDTO';
import { TransferServiceImpl } from '../../domain/Transfer/usecases';
import { TransferConfirm } from './TransferConfirm';
import { TransferComplete } from './TransferComplete';
import { InitTransferStep } from './InitTransferStep';
import { TransferOTP } from './TransferOTP';

const useFundsTransferFlowConfig = (
  toggleStepperIsActive: Function,
  service: TransferServiceImpl,
  transferType?: RoutingTransferTypes,
): ClientSideWizardConfiguration => {
  const beneficiariesIsAllowed = useUserInfoIsUserAllowedAction(UserAppTransaction.AliasList);
  switch (transferType) {
    case RoutingTransferTypes.INTERNAL_SAME_CURRENCY:
    case RoutingTransferTypes.INTERNAL_OTHER_CURRENCY:
      return {
        data: {
          initTransfer: {
            stepId: 'initTransfer',
            isFirstStep: true,
            cancelHidden: false,
            hasStepIndicator: true,
            Component: () => <InitTransferStep toggleStepperIsActive={toggleStepperIsActive} service={service} />,
            parameters: {},
          },
          transferConfirm: {
            stepId: 'transferConfirm',
            backable: true,
            cancelHidden: true,
            hasStepIndicator: true,
            Component: (props: any) => (
              <TransferConfirm
                externalEffectCallbacks={props.externalEffectCallbacks}
                isSaveBeneficiaryButtonEnabled={false}
                service={service}
              />
            ),
            parameters: {},
          },
          END: {
            stepId: 'END',
            cancelHidden: true,
            Component: () => <TransferComplete service={service} />,
            parameters: {},
          },
        },
        currentStep: null,
      };

    default:
      return {
        data: {
          initTransfer: {
            stepId: 'initTransfer',
            isFirstStep: true,
            cancelHidden: false,
            hasStepIndicator: true,
            Component: () => <InitTransferStep toggleStepperIsActive={toggleStepperIsActive} service={service} />,
            parameters: {},
          },
          transferConfirm: {
            stepId: 'transferConfirm',
            backable: true,
            cancelHidden: true,
            hasStepIndicator: true,
            Component: (props: any) => (
              <TransferConfirm
                externalEffectCallbacks={props.externalEffectCallbacks}
                isSaveBeneficiaryButtonEnabled={beneficiariesIsAllowed}
                service={service}
              />
            ),
            parameters: {},
          },
          transferOTP: {
            stepId: 'transferOTP',
            isFirstStep: false,
            hasStepIndicator: true,
            cancelHidden: true,
            backable: false,
            Component: TransferOTP,
            parameters: {},
          },
          END: {
            stepId: 'END',
            cancelHidden: true,
            Component: () => <TransferComplete service={service} />,
            parameters: {},
          },
        },
        currentStep: null,
      };
  }
};

export { useFundsTransferFlowConfig };
